import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'find',
    standalone: false
})
export class FindPipe implements PipeTransform {
  transform(list: any, key: any, value: any) {
    return list?.find(l => l[key] === value);
  }
}
